import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { itemsPerPage } from '@hotjar/insights-common/constants/legacy';

export const LOCAL_STORAGE_KEY = 'itemsPerPage';

export const getItemsPerPage = (): number => {
  const value = parseInt(String(LocalStorage.get(LOCAL_STORAGE_KEY)), 10);

  // If it's not, remove it from LS and return the default value
  //
  // @see https://hotjar.atlassian.net/browse/IN-120
  if (Number.isNaN(value)) {
    LocalStorage.remove(LOCAL_STORAGE_KEY);
    return Number(itemsPerPage);
  }

  return value;
};

export const setItemsPerPage = (value: number | string): void => {
  const parsedValue = parseInt(String(value), 10);

  // For pagination, 0 as itemsPerPage should not be saved as it doesn't make sense logically
  if (Number.isNaN(parsedValue) || parsedValue === 0) {
    return;
  }

  LocalStorage.set(LOCAL_STORAGE_KEY, parsedValue);
};
